module.exports = __webpack_public_path__ + "img/directionRight-white.34b45acd.svg";